module.exports = __webpack_public_path__ + "img/Newcastle.7dbea3cf.jpg";